<ul class="grid row">
    <li *ngFor="let ovenConfiguration of ovenConfigurations" [class.active]="current.ovenConfigurationRef === ovenConfiguration.id" class="col-6">
        <figure (click)="selectOvenConfiguration(ovenConfiguration.id)">
            <span class="media">
                <img class="vertical" [src]="'assets/img/'+ovenConfiguration.img" [alt]="ovenConfiguration.titleRef | translate">
                <span class="state">
                    <svg class="icon-action-select-thumb" aria-hidden="true">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/img/icons.svg#icon-action-select-thumb"></use>
                    </svg>
                </span>
            </span>
            <figcaption>
                <p>{{ ovenConfiguration.titleRef | translate }}</p>
                <p *ngIf="ovenConfiguration.subTitleRef"><small>{{ ovenConfiguration.subTitleRef | translate }}</small></p>
            </figcaption>
        </figure>
    </li>
</ul>
<div class="text-center">
    <label class="bt-text" (click)="selectOvenConfiguration('')">{{ "need_mapping.no_choice.info" | translate }}</label>
</div>